export default function About() {
  return (
    <div className="flex min-h-[700px]">
      {/* Left Column - Image with Text Overlay */}
      <div className="w-1/2 bg-[#f5f1eb] relative overflow-hidden">
        <img
          src="https://public.readdy.ai/ai/img_res/5de2145f1482c716b00f6b57b3d0ba51.jpg"
          alt="MIKRA Team"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
        
        {/* Text Overlay */}
        <div className="absolute bottom-0 left-0 p-16">
          <div className="text-[10px] uppercase tracking-[1.8px] text-[#e8e8e8] mb-10 font-medium">
            ABOUT US / SINCE 2024
          </div>
          <div className="leading-[0.9]">
            <div className="text-[68px] font-bold text-white">Expert</div>
            <div className="text-[76px] font-bold text-white">iOS</div>
            <div className="text-[84px] font-bold text-white">Developers</div>
          </div>
        </div>
      </div>

      {/* Right Column - Content */}
      <div className="w-1/2 bg-white flex flex-col items-center justify-center px-24">
        <div className="text-center">
          <h2 className="text-[56px] font-bold text-black leading-tight mb-2">
            Dedicated to
          </h2>
          <h2 className="text-[56px] font-bold text-black leading-tight mb-16">
            Mobile Innovation
          </h2>
          
          <p className="text-[15px] leading-[1.9] text-[#5a5a5a] max-w-[520px] mx-auto">
            At MIKRA d.o.o., we are passionate about creating exceptional iOS applications that make a difference in users' daily lives. Our team of experienced developers combines technical expertise with creative vision to deliver products that are both powerful and intuitive. We believe in the importance of security, performance, and user-centric design in every application we build.
          </p>

          {/* Visual Accent */}
          <div className="mt-20 w-[180px] h-[52px] bg-[#3d3028] rounded-full mx-auto flex items-center justify-center">
            <i className="ri-arrow-right-line text-[#e8dcc8] text-xl"></i>
          </div>
        </div>
      </div>
    </div>
  );
}
